var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 565,
    height: 57,
    viewBox: "0 0 565 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01195 30.2951C47.9252 36.838 67.7869 -1.80082 162.232 2.62549C172.362 3.10027 183.853 5.10904 196.5 8.07466C209.147 11.0403 219.5 17 219.5 17M563.989 25.8685C480.612 -0.325091 455.637 62.3793 385.43 54.6445C370.898 53.0435 354.292 49.0954 348.5 48.5",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLine);
export default __webpack_public_path__ + "static/media/error-line.644ee511230ec2fdab38cea4e655c117.svg";
export { ForwardRef as ReactComponent };